import dayjs from 'dayjs';
import { useState } from 'react';
import { AgendaFilter } from '../models';
import { DeleteForever as TrashIcon } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Search as SearchIcon } from '@mui/icons-material';
import { DateInput } from '@/components';

import styles from './SearchBar.module.css';

interface SearchBarProps {
  search: (data: AgendaFilter) => void;
  filterInitialValues: AgendaFilter;
  filterDefaultValues: AgendaFilter;
}

const SearchBar = ({
  search,
  filterInitialValues,
  filterDefaultValues,
}: SearchBarProps) => {
  const [localFilter, setLocalFilter] =
    useState<AgendaFilter>(filterDefaultValues);

  const validateDate = () => {
    const dateOpenFrom = dayjs(localFilter.dateOpenFrom);
    const dateOpenTo = dayjs(localFilter.dateOpenTo);

    if (dateOpenFrom.isAfter(dateOpenTo)) {
      alert("Fecha 'Desde' es mayor que fecha 'Hasta'.");
      return false;
    }

    if (Math.abs(dateOpenFrom.diff(dateOpenTo, 'day')) > 15) {
      alert('No se puede buscar si el rango es mayor a 15 días.');
      return false;
    }

    return true;
  };

  const saveFiltersToLocalStorage = (filters: AgendaFilter) => {
    localStorage.setItem('AGENDAS-FILTERS', JSON.stringify(filters));
  };

  const resetFilters = () => {
    setLocalFilter(filterInitialValues);
    search(filterInitialValues);
    saveFiltersToLocalStorage(filterInitialValues);
  };

  const handleSearch = () => {
    if (!validateDate()) return;
    search(localFilter);
    saveFiltersToLocalStorage(localFilter);
  };

  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', gap: '10px' }}>
        <DateInput
          name='date-open-from-search'
          placeholder='Fecha desde'
          value={
            localFilter.dateOpenFrom ? new Date(localFilter.dateOpenFrom) : null
          }
          onChange={(newValue) =>
            setLocalFilter({
              ...localFilter,
              dateOpenFrom: newValue
                ? newValue.toISOString()
                : localFilter.dateOpenFrom,
            })
          }
        />
        <DateInput
          name='date-open-to-search'
          placeholder='Fecha hasta'
          value={
            localFilter.dateOpenTo ? new Date(localFilter.dateOpenTo) : null
          }
          onChange={(newValue) =>
            setLocalFilter({
              ...localFilter,
              dateOpenTo: newValue
                ? newValue.toISOString()
                : localFilter.dateOpenTo,
            })
          }
        />
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilters}
        >
          <TrashIcon color={'primary'} />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color={'primary'} />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
